import { useState } from 'react';
import { toggleProposedDoc } from '../../../api/prospectApi';
import './DocChecklistBuilder.css';

const CATEGORY_LABELS = {
  KYC:        'KYC',
  MF:         'Mutual Funds',
  EQUITY:     'Equity / Demat',
  BONDS:      'Bonds / Debentures',
  INSURANCE:  'Insurance',
  PF_NPS:     'EPF / NPS / PF',
  FD:         'Fixed Deposits',
  REAL_ESTATE:'Real Estate',
  OTHER:      'Other Assets',
};

export default function DocChecklistBuilder({ prospectId, proposedDocItems, onJourneyUpdated, readOnly }) {
  const [togglingKey, setTogglingKey] = useState(null);

  const items = proposedDocItems || [];

  async function handleToggle(item) {
    setTogglingKey(item.doc_key);
    try {
      const updated = await toggleProposedDoc(prospectId, item.doc_key, !item.selected, item.notes);
      onJourneyUpdated(updated);
    } catch (ex) {
      console.error('Failed to toggle doc item:', ex);
    } finally {
      setTogglingKey(null);
    }
  }

  return (
    <div className="dcb__section">
      <div className="dcb__header">
        <span className="dcb__heading">📋 Document Checklist</span>
        <span className="dcb__subtitle">Select which documents apply to this client</span>
      </div>

      <div className="dcb__list">
        {items.map(item => (
          <div
            key={item.doc_key}
            className={`dcb__row ${!item.selected ? 'dcb__row--unchecked' : ''}`}
          >
            <label className="dcb__row-label">
              <input
                type="checkbox"
                className="dcb__checkbox"
                checked={!!item.selected}
                disabled={readOnly || togglingKey === item.doc_key}
                onChange={() => !readOnly && handleToggle(item)}
              />
              <div className="dcb__row-info">
                <span className="dcb__category">
                  {CATEGORY_LABELS[item.category] || item.category}
                  {item.level > 0 && <span className="dcb__level-badge">L{item.level}</span>}
                </span>
                <span className="dcb__subcategory">{item.subcategory}</span>
              </div>
            </label>
          </div>
        ))}
      </div>

      <div className="dcb__footer">
        Unchecked items will be excluded from the Document Collection stage.
      </div>
    </div>
  );
}
